<template>
  <v-btn fab @click="$emit('click')">
    <v-img contain width="24" height="24" :src="$asset('img/icons/cross.svg')" />
  </v-btn>
</template>

<script>
export default {
  name: 'CloseButton'
};
</script>
